
import { Vue, Component, Prop } from "vue-property-decorator";
import EditForm from "@/views/Components/editForm.vue";
import OrderStatus from "./OrderStatus.vue";

import { PhoneRegExp, EmailRegExp } from "@/contants/regExp";
import { current } from "@/contants/current";

@Component({ components: { EditForm, OrderStatus } })
export default class SelfInfo extends Vue {
  private flags: any = {
    isEdit: false,
    payType: 1,
  };
  private orderData: any = {}; //订单数据

  @Prop({
    type: Object,
    default: {},
    required: true,
  })
  datas!: any;
  created() {
    console.log("this.datas", this.datas);
	console.log("allowUpdateInfo", (this as any).allowUpdateInfo);
  }
  handleIsEdit(isEdit: any) {
    this.flags.isEdit = isEdit;
  }
  getPaytype(data: any){
    console.log(data)
    this.flags.payType = data
    this.$emit('sendPaytypes', data)
  }
}
